export {
  CloseOnFocus as UNSAFE_CloseOnFocus,
  OverlayTrigger,
  useOverlayTriggerContext as UNSAFE_useOverlayTriggerContext,
} from './OverlayTrigger'
export type { OverlayTriggerProps } from './OverlayTrigger.types'
